// extracted by mini-css-extract-plugin
export default {"container":"PartnersSection_container__xyynD","logo":"PartnersSection_logo__st1LM"};